export const MANTRA_PRESETS = [
  {
    theme: 'Perseverance',
    mantras: [
      'One more mile.',
      'Pain is temporary, pride is forever.',
      "I didn't come this far to only come this far.",
      'Relentless forward progress.',
      'The body achieves what the mind believes.',
      'Strong legs, brave heart.',
    ],
  },
  {
    theme: 'Strength',
    mantras: [
      'I am built for this.',
      'Suffer now, celebrate later.',
      "Run the mile you're in.",
      'Today I choose to be unstoppable.',
      'My legs are strong, my lungs are ready.',
    ],
  },
  {
    theme: 'Joy',
    mantras: [
      'Run happy.',
      'This is my victory lap.',
      'I run because I can.',
      'Find joy in every stride.',
      'Smile — you trained for this.',
    ],
  },
  {
    theme: 'Focus',
    mantras: [
      'Smooth and steady.',
      'Trust the training.',
      'One step at a time.',
      'Stay present, stay strong.',
      'Control what you can, release the rest.',
    ],
  },
];
